<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0 mb-5 pb-5">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col mb-5">
        <h1 class="text-center py-4">Ventas</h1>
        <FilterMenu  :filterMenu="true" typePublication="product" :filterName="true" :filterAmountElements="true" />
        <div class="container">
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col">Comprador</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Codigo</th>
                <th class="d-none d-sm-table-cell" scope="col">Sacoin</th>
                <th class="d-none d-md-table-cell" scope="col">Fecha</th>
                <th scope="col">Reclamo</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="text-center" v-if="purchaseFiltered.length">
              <tr v-for="purchase in purchaseFiltered" :key="purchase._id">
                <td>{{purchase.buyer.username}}</td>
                <td>{{purchase.seller.username}}</td>
                <td>{{purchase.prettyID}}</td>
                <td class="d-none d-sm-table-cell" >SC${{(purchase.sacoin + purchase.financiamiento).toFixed(2)}}</td>
                <td class="d-none d-md-table-cell">{{purchase.creationDate.replace(/T/, ' ').replace(/\..+/, '')}}</td>
                <td><span v-if="purchase.claim" class="badge badge-danger p-2">Si</span></td>
                <td> <router-link :to="{name: 'AdminPurchase', params: {id: purchase._id}}"><span class="material-icons text-info" >settings</span></router-link></td>
              </tr>
            </tbody>
            <tbody  v-else>
              <tr>
                <td colspan="8" class="text-center">
                  No hay ninguna venta que cumpla con el filtro
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import FilterMenu from "@/components/admin/FilterMenu.vue";
import Configs from "@/configs/configs";
import Api from "../../tools/Api2"
import { mapState } from "vuex";

export default {
  name: "AdminPurchases",
  data() {
    return {
      purchases: [],
      url: Configs.API.BASE,
      filterMenuParms: {
        filterName: "",
        filterAmountElements: 50,
        filterState: {
          0: true,
          1: true,
          2: true,
        },
        orderBy: {
          sort: "creationDate",
          asc: false,
        },
      },
    };
  },
  computed: {
    ...mapState(["auth", "changes"]),
    purchaseFiltered() {
      return this.purchases
        .filter((e) => (e.seller.username.toUpperCase().includes(this.filterMenuParms.filterName.toUpperCase()) || e.buyer.username.toUpperCase().includes(this.filterMenuParms.filterName.toUpperCase()) || e.prettyID.toString().includes(this.filterMenuParms.filterName)))
        .sort((a, b) => {
          if (
            this.filterMenuParms.orderBy.asc
              ? a[this.filterMenuParms.orderBy.sort] >
                b[this.filterMenuParms.orderBy.sort]
              : a[this.filterMenuParms.orderBy.sort] <
                b[this.filterMenuParms.orderBy.sort]
          ) {
            return 1;
          }
          if (
            this.filterMenuParms.orderBy.asc
              ? a[this.filterMenuParms.orderBy.sort] <
                b[this.filterMenuParms.orderBy.sort]
              : a[this.filterMenuParms.orderBy.sort] >
                b[this.filterMenuParms.orderBy.sort]
          ) {
            return -1;
          }
          return 0;
        }).slice(0, this.filterMenuParms.filterAmountElements);
    },
  },
  methods: {},
  components: {
    NavbarMain,
    NavbarAdmin,
    FilterMenu,
  },
  created: function () {
    Api('buy').get().then( res => {
      this.purchases = res.buys
    })
  },
};
</script>
